import { render, staticRenderFns } from "./SummaryGeneral.vue?vue&type=template&id=3ac88b73&scoped=true&"
import script from "./SummaryGeneral.vue?vue&type=script&lang=js&"
export * from "./SummaryGeneral.vue?vue&type=script&lang=js&"
import style1 from "./SummaryGeneral.vue?vue&type=style&index=1&id=3ac88b73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac88b73",
  null
  
)

export default component.exports